import {
  Fab, FormControl,
} from '@material-ui/core';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {
  DatePicker,
} from '@material-ui/pickers';
import {
  ParsableDate,
} from '@material-ui/pickers/constants/prop-types';
import {
  inject, observer,
} from 'mobx-react';
import moment from 'moment';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  StatusValue,
} from '../../axios/newsRequests';
import AlertDialog from '../../components/Dialog/alertDialog';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import SearchFilterDropdown from '../../components/SearchFilterComponent/SearchFilterDropdown';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import {
  DefaultLanguage,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  INewsAndAnnouncementStore,
  FilterArticlesOptions,
} from '../../mobx-store/storeInterfaces/newsAndAnnouncementInterface';
import {
  INewsCategoryStore,
} from '../../mobx-store/storeInterfaces/newsCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './news.module.scss';

import DynamicLinkDialog from './dynamicLinkDialog';

interface IProps extends WithSnackbarProps {
  type: 'news' | 'announcement';
  newsAndAnnouncementStore: INewsAndAnnouncementStore;
  countryStore: CountryStore;
  newsCategoryStore: INewsCategoryStore;
  history?: any;
}

interface State {
  liveStatus: StatusValue;
  status: string;
  categoryId: number;
  publishDate: Date | null;
  open: boolean;
  title: string;
  dynamicLinkDialogOpen: boolean;
  selectedDynamicLink: string;
}

@inject('newsCategoryStore')
@inject('countryStore')
@inject('newsAndAnnouncementStore')
@observer
class News extends Component<IProps, State> {
  addButton: any;

  tableHeader: any = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  liveStatusSearchFilterDropdown: any;

  liveStatusFilterRef: SearchFilterDropdown;

  statusFilterRef: SearchFilterDropdown;

  statusSearchFilterDropdown: any;

  articleType: ('featured' | 'homeTile' | 'both') = 'both';

  handleAgree: () => void = () => null;

  constructor(props: IProps, state: State) {
    super(props);
    this.linkCloseButton = this.linkCloseButton.bind(this);
    this.title = translate(`${this.props.type}ListPageTitle`, {
    });
    this.state = {
      status: 'all',
      liveStatus: 'all',
      categoryId: 0,
      open: false,
      publishDate: null,
      title: '',
      dynamicLinkDialogOpen: false,
      selectedDynamicLink: '',
    };
  }

  componentWillMount() {
    this.setState({
      categoryId: 0, publishDate: null,
    });
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    if (this.props.type === 'news') {
      this.props.history.push(`/news/${this.props.newsAndAnnouncementStore.articlesList[index].articleId}/edit`);
    } else {
      this.props.history.push(`/academies-announcements/${this.props.newsAndAnnouncementStore.articlesList[index].articleId}/edit`);
    }
  };

  linkCloseButton() {
    SnackBarComponent.getInstance().openSnackbar(translate('copyMessage', {
    }), 8000, 'success');
    this.setState({
      selectedDynamicLink: '',
      dynamicLinkDialogOpen: false
    });
  }
  
  generateOrCopyDeepLink = async (index: number , key: string) => {
    try {
      const { articleId , dynamicLink } = this.props.newsAndAnnouncementStore.articlesList[index];
      console.log('articleId , dynamicLink', articleId , dynamicLink);
      if (!dynamicLink) {
        await this.props.newsAndAnnouncementStore.generateDeepLink(articleId);
        await this.componentDidMount();
      }
      this.setState({
        selectedDynamicLink: this.props.newsAndAnnouncementStore.articlesList[index].dynamicLink,
        dynamicLinkDialogOpen: true
      });
    } catch (error) {
      console.log('error' , error);
      SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
      }), 8000, 'error');
    }
  };

  handelAdd = (): void => {
    if (this.props.type === 'news') {
      this.props.history.push('/news/new');
    } else {
      this.props.history.push('/academies-announcements/new');
    }
  };

  getAddArticleButton = () => ({
    title: translate('addButton', {
    }),
    onAdd: this.handelAdd,
  });

  getArticleLiveStatusSearchFilterDropDown = () => ({
    value: this.state.liveStatus,
    initialValue: 'all',
    onChange: this.selectLiveStatusSearchChange.bind(this),
    filters: [{
      value: 'all', name: 'All',
    },
    {
      value: 'published', name: 'Published',
    },
    {
      value: 'unpublished', name: 'Unpublished',
    }],
  });

  getArticleStatusSearchFilterDropDown = () => ({
    value: `${this.state.status}`,
    initialValue: 'all',
    onChange: this.selectStatusSearchChange.bind(this),
    filters:
      [
      {
        value: 'all', name: 'All',
      },
      {
      value: 'active', name: 'Active',
      },
      {
        value: 'inactive', name: 'Not Active',
      }],
  });

  getArticleTableHeader = () => [
    {
      title: translate('newsListArticleColumnTitle', {
      }),
    },
    {
      title: translate('newsListStatusColumnTitle', {
      }),
    },
    {
      title: translate('newsListCategoryColumnTitle', {
      }),
    },
    {
      title: translate('newsListStartDateColumnTitle', {
      }),
    },
    {
      title: translate('newsListEndDateColumnTitle', {
      }),
    },
    {
      title: translate('newsListLiveColumnTitle', {
      }),

    },
    {
      title: translate('newsListEditColumnTitle', {
      }),
    },
    {
      title: translate('newsListDynamicLink', {
      }),
    },
  ];

  getArticleTableData = () => this.props.newsAndAnnouncementStore.articlesList
    .map((article) => ({
      ...article,
      edit: translate('newsListEditButton', {
      }),
      generate: translate('newsListEditButton', {
      }),
    }));

  getArticleTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'ToggleButton',
      key: 'isActive',
      activeLabel: translate('newsListStatusActive', {
      }),
      inactiveLabel: translate('newsListStatusInactive', {
      }),
      onChange: this.handleTableToggleCellChange,
    },
    {
      cellType: 'Text',
      key: 'articleCategory',
    },
    {
      cellType: 'Text',
      key: 'startDate',
    },
    {
      cellType: 'Text',
      key: 'endDate',
    },
    {
      cellType: 'Text',
      key: 'isPublished',

    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
    {
      cellType: 'Button',
      key: 'deepLink',
      onClick: this.generateOrCopyDeepLink
    }
  ];

  selectLiveStatusSearchChange(newFilter: any) {
    this.setState({
      liveStatus: newFilter,
    });
  }

  selectStatusSearchChange(newFilter: any) {
    this.setState({
      status: newFilter,
    });
  }

  handleSearchChanged = (title: any, isSearching: boolean) => {
    this.setState({
      title,
    });

    // isActive status check
    const isActive = this.state.status === "all" ? null : this.state.status === 'active';


    if (title) {
      const params: FilterArticlesOptions = {
        publishDate: new Date(this.state.publishDate!).getTime(),
        categoryId: this.state.categoryId,
        isActive,
        type: this.props.type,
        query: title,
        countries: this.props.countryStore.managedCountries,
        langCode: DefaultLanguage,
      };
      this.props.newsAndAnnouncementStore.filterArticles(params);
    } else {
      this.props.newsAndAnnouncementStore.getArticles(this.props.type, this.state.liveStatus, this.props.countryStore.managedCountries);
    }
  };

  handleClearSearch = () => {
    this.setState({
      title: '',
    });

    // isActive status check
    const isActive = this.state.status === "all" ? null : this.state.status === 'active';

    const params: FilterArticlesOptions = {
      publishDate: new Date(this.state.publishDate!).getTime(),
      categoryId: this.state.categoryId,
      isActive,
      type: this.props.type,
      query: '',
      countries: this.props.countryStore.managedCountries,
      langCode: DefaultLanguage,
    };
    this.props.newsAndAnnouncementStore.filterArticles(params)
  };

  handleCategoryChanged = (categoryId: number) => {
    this.setState({
      categoryId,
    });

    // isActive status check
    const isActive = this.state.status === "all" ? null : this.state.status === 'active';
    
    const params: FilterArticlesOptions = {
      publishDate: new Date(this.state.publishDate!).getTime(),
      categoryId: categoryId,
      isActive,
      type: this.props.type,
      query: this.state.title,
      countries: this.props.countryStore.managedCountries,
      langCode: DefaultLanguage,
    };
    this.props.newsAndAnnouncementStore.filterArticles(params)
  };

  handleDateChanged = (publishDate: Date) => {

    this.setState({
      publishDate,
    });

    // isActive status check
    const isActive = this.state.status === "all" ? null : this.state.status === 'active';

    const params: FilterArticlesOptions = {
      publishDate: new Date(publishDate).getTime(),
      categoryId: this.state.categoryId,
      isActive,
      type: this.props.type,
      query: this.state.title,
      countries: this.props.countryStore.managedCountries,
      langCode: DefaultLanguage,
    };
    this.props.newsAndAnnouncementStore.filterArticles(params)
  };

  handleClearFilter = () => {
    this.setState({
      status: 'all',
      liveStatus: 'all',
      categoryId: 0,
      open: false,
      publishDate: null,
      title: '',
    }, () => {
      this.liveStatusFilterRef.clear();
      this.statusFilterRef.clear();
      this.props.newsAndAnnouncementStore.getArticles(this.props.type,
      this.state.liveStatus, this.props.countryStore.managedCountries);  
    });
  };

  handleTableToggleCellChange = (index: number, key: string, value: boolean) => {
    const currentArticle = this.props.newsAndAnnouncementStore.articlesList.filter((a, i) => i === index);
    if (!value && currentArticle && currentArticle[0] && currentArticle[0].isFeatured && currentArticle[0].isHomeTile) {
      this.articleType = 'both';
      this.handleAgree = () => {
        this.props.newsAndAnnouncementStore.updateArticleStatus(value, index)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else if (!value && currentArticle && currentArticle[0] && currentArticle[0].isFeatured) {
      this.articleType = 'featured';
      this.handleAgree = () => {
        this.props.newsAndAnnouncementStore.updateArticleStatus(value, index)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else if (!value && currentArticle && currentArticle[0] && currentArticle[0].isHomeTile) {
      this.articleType = 'homeTile';
      this.handleAgree = () => {
        this.props.newsAndAnnouncementStore.updateArticleStatus(value, index)
          .then(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
          })
          .catch(() => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          open: false,
        });
      };
      this.handleClickOpen();
    } else {
      this.props.newsAndAnnouncementStore.updateArticleStatus(value, index)
        .then(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 8000, 'success');
        })
        .catch(() => {
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 8000, 'error');
        });
    }
    console.log(this.articleType);
  };

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = () => {
    this.setState({
      open: false,
    });
  };

  handleDialogContent = (): string => {
    if (this.articleType === 'featured') {
      return translate('featuredNewsListDeactivationWarning', {
      });
    } if (this.articleType === 'homeTile') {
      return translate('homeTileNewsListDeactivationWarning', {
      });
    }
    return translate('homeTileAndFeaturedNewsListDeactivationWarning', {
    });
  };

  render() {
    this.addButton = this.getAddArticleButton();
    this.tableHeader = this.getArticleTableHeader();
    this.tableCellTypes = this.getArticleTableCellTypes();
    this.liveStatusSearchFilterDropdown = this.getArticleLiveStatusSearchFilterDropDown();
    this.statusSearchFilterDropdown = this.getArticleStatusSearchFilterDropDown();

    return (
      <div className={classes.container}>
        <DynamicLinkDialog link={this.state.selectedDynamicLink} open={this.state.dynamicLinkDialogOpen} handleClose={this.linkCloseButton}/>
        <div className={classes.searchContainer}>
          <GeneralSearchComponent
            onSearchClick={this.handleSearchChanged}
            searchBy="title"
            onClearSearch={this.handleClearSearch}
          />
          {/* <InputLabel htmlFor="name-native-disabled" className={classes.categorySearchLabel}>Search By Category</InputLabel> */}
          <div className={classes.newsSearch}>
            <FormControl className={classes.formControl}>
              <InputLabel htmlFor="age-native-simple">Search By Category</InputLabel>
              <Select
                className={classes.select}
                value={this.state.categoryId}
                onChange={(event) => {
                  this.handleCategoryChanged(parseInt((event.target.value as any), 10));
                }}
                inputProps={{
                  name: 'search',
                  id: 'search-simple',
                }}
              >
                {this.props.newsCategoryStore.categoriesFilterList.map((item: any, index: number) => (
                  <MenuItem value={item.categoryId} key={item.categoryId}>{item.title}</MenuItem>
                ))}

              </Select>
            </FormControl>
            <DatePicker
              clearable
              variant="inline"
              className={classes.datePicker}
              label="Search By Publish Date"
              name="datasearch"
              format="dd/MM/yyyy"
              value={this.state.publishDate}
              views={['year', 'month', 'date']}
              onChange={(value) => {
                this.handleDateChanged(value as any || new Date() as any);
              }}
            />
          </div>
          <div className={classes.filters}>
            <SearchFilterDropdown 
              ref={(ref) => {
                if(ref) this.liveStatusFilterRef = ref
              }} 
              label="Live Status" 
              searchFilterDropdown={this.liveStatusSearchFilterDropdown} 
            />
            <SearchFilterDropdown 
              ref={(ref) => {
                if(ref) this.statusFilterRef = ref
              }}           
              label="Status" 
              searchFilterDropdown={this.statusSearchFilterDropdown} 
            />
          </div>
          <Fab
            onClick={() => this.handleClearFilter()}
            color="primary"
            variant="extended"
            className={classes.clearFilterButton}
          >
            {translate('newsListClearFiltersButton', {
            })}
          </Fab>
        </div>
        <GeneralTableComponent
          emptyMessage={translate(`${this.props.type}ListNoArticlesMessage`, {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.props.newsAndAnnouncementStore.articlesList}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.newsAndAnnouncementStore.getNewsRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
        <AlertDialog
          title={translate(`${this.props.type}ListPageTitle`, {
          })}
          content={this.handleDialogContent()}
          isOpen={this.state.open}
          agree={this.handleAgree}
          disAgree={this.handleClose}
          hasActions
        />
      </div>
    );
  }

  async componentDidUpdate(prevProps: any, prevState: any) {
    if (this.state.liveStatus !== prevState.liveStatus) {
      this.props.newsAndAnnouncementStore.getArticles(this.props.type,
        this.state.liveStatus,
        this.props.countryStore.managedCountries);
    }
    if (this.state.status !== prevState.status) {

      // isActive status check
      const isActive = this.state.status === "all" ? null : this.state.status === 'active';

      const params: FilterArticlesOptions = {
        publishDate: new Date(this.state.publishDate!).getTime(),
        categoryId: this.state.categoryId,
        isActive,
        type: this.props.type,
        query: this.state.title,
        countries: this.props.countryStore.managedCountries,
        langCode: DefaultLanguage,
      };
      this.props.newsAndAnnouncementStore.filterArticles(params)
    }
  }

  async componentDidMount() {
    await this.props.countryStore.getUserManagedCountries();
    await this.props.newsAndAnnouncementStore.getArticles(this.props.type,
      this.state.liveStatus,
      this.props.countryStore.managedCountries);
    this.props.newsCategoryStore.getArticlesCategories(this.props.countryStore.managedCountries);
  }

  openSnackbar = (message: string, duration: number, status: 'success' | 'warning' | 'error' | 'info') => {
    this.props.enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button color="default">Dismiss</Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };
}

export default News;
